import React, { useEffect, useState } from 'react';
import { useLocation, useHistory, Redirect } from 'react-router-dom';
import qs from 'qs';
import styles from './index.module.scss';

import { Loader, ConfirmSessionSwitch } from 'components';
import { useAuthGuard, useMutation } from 'utils/hooks';
import { logout } from 'utils/services';
import { getCredentialSearch } from 'utils/credentialUrl';
import { getActiveSessionStoreName } from 'utils/DICTIONARY';

export default function ExternalSignIn() {
  const { search } = useLocation();
  const { replace } = useHistory();

  const { onAuthenticated } = useAuthGuard();

  // An existing session must not be replaced without the user's consent
  const [currentStore] = useState(getActiveSessionStoreName);
  const [isConfirmed, setIsConfirmed] = useState(!currentStore);

  const { token, store } = qs.parse(getCredentialSearch(search).slice(1));

  const { mutate: signIn } = useMutation('auth.externalLogin', 'POST', {
    payload: { token },
    ignoreReadModeCheck: true,
    errorMessage: "We couldn't log you in. Please try again.",
    onSuccess: data => onAuthenticated(data),
    onError: () => replace('/login')
  });

  useEffect(() => {
    if (token && isConfirmed) {
      logout(() => signIn());
    }
  }, [token, isConfirmed, signIn]);

  if (!token) return <Redirect to="/" />;

  if (!isConfirmed) {
    return (
      <ConfirmSessionSwitch
        currentStore={currentStore}
        targetStore={store}
        onConfirm={() => setIsConfirmed(true)}
        onCancel={() => replace('/')}
      />
    );
  }

  return (
    <div className={styles.container}>
      <Loader loading spinnerClassName={styles.spinner} />
      <span className={styles.content}>
        Provisioning access to <strong>"{store || 'the store'}"</strong>...
      </span>
    </div>
  );
}
